import React from 'react';
import MessagingTemplatesLayout from '../../../layouts/messagingSectionLayout';
import MessagingTemplateCollection from '../../../layouts/messagingSectionLayout/messagingTemplateCollection';
import { APP_PLAYBOOK_MESSAGING_PITCH_FORM } from '../../../app/_constants/routes';
import { FORM_MODES, TEMPLATE_TYPES } from '../../../utils/templates.utils';
import { TYPES } from '../../../constants/templates';
import { useRouter } from '../../../hooks';
import MessagingMineSwitch from '../../../components/messagingTemplates/messagingMineSwitch/messagingMineSwitch';
import MessagingBattlecardsFilterSwitch from '../../../components/messagingTemplates/messagingBattlecardsFilterSwitch/messagingBattlecardsFilterSwitch';
import MessagingOfficialFilterSwitch from '../../../components/messagingTemplates/messagingOfficialFilterSwitch/messagingOfficialFilterSwitch';
import { useSnippetsEnabled } from '../../../hooks/useFeatureFlags';

const PitchTemplatesPage = () => {
  const { history } = useRouter();
  const hasSnippetsEnabled = useSnippetsEnabled();

  const config = {
    actionName: 'Create template',
    onClickAction: e =>
      history.push(`${APP_PLAYBOOK_MESSAGING_PITCH_FORM}?mode=${FORM_MODES.CREATION}`, {
        event: e,
      }),
    searchPlaceholder: 'Search',
  };

  return (
    <MessagingTemplatesLayout
      dataIntercom="account-settings-pitch-template-page"
      body={<MessagingTemplateCollection templateType={TEMPLATE_TYPES.PITCH} />}
      actions={
        <>
          <MessagingOfficialFilterSwitch />
          <MessagingBattlecardsFilterSwitch />
          <MessagingMineSwitch />
        </>
      }
      type={TYPES.PITCH}
      id="PITCH_MESSAGING_TEMPLATES"
      title={hasSnippetsEnabled ? 'Pitches' : 'Pitches & Snippets'}
      createConfig={config}
      pluralEntityName="Pitch templates"
    />
  );
};

export default PitchTemplatesPage;
